// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1Dy0g","label":"styles_label__Y6DfH","value":"styles_value__OhHdE","skeleton-animation":"styles_skeleton-animation__l0vyZ"};